function normalizeBlocks(entry) {
  const raw = entry.blocks || entry.content?.blocks || entry.content;

  if (Array.isArray(raw)) {
    return raw.map((block) => {
      if (block?.type === "model") block.type = "model3d";
      return block;
    });
  }

  if (typeof raw === "string") {
    return [
      {
        type: "paragraph",
        data: { text: raw.replace(/\n/g, "<br>") },
      },
    ];
  }

  return [];
}

function slugify(title = "") {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

function getApiBase() {
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return ""; // nutzt CRA-Proxy -> https://www.denisbitter.de/stage01/api
  }
  return "https://www.denisbitter.de/stage01/api";
}

export async function loadCase() {
  const all = [];

  try {
    const apiBase = getApiBase();
    const res = await fetch(`${apiBase}/case.php`);
    const filenames = await res.json();

    for (const file of filenames) {
      try {
        const articleRes = await fetch(`${apiBase}/case.php?slug=${file}`);
        const json = await articleRes.json();

        all.push({
          ...json,
          blocks: normalizeBlocks(json),
          slug: slugify(json.title || "unbenannt"),
        });
      } catch (err) {
        console.warn(`⚠️ Artikel ${file} konnte nicht geladen werden:`, err);
      }
    }
  } catch (e) {
    console.error("❌ Fehler beim Laden der Caseliste:", e);
  }

  return all;
}
